import React, { useState } from 'react';
import './add-brand-lift-study.scss';
import { DashboardHeader } from '../../atoms';
import { AddBlsData, DashContentFooter } from '../../molecules';
import { DashboardContext } from '../../../context';
import { useHistory } from 'react-router-dom';


function AddBrandLiftStudy() {
    const history = useHistory();
  const [dashData, setDashData] = useState({});  

  const handleBackClick = () => {
    history.push('/bls_insights');
  };
      return (
        <DashboardContext.Provider value={{ dashData, setDashData }}>
          <div className='row no-gutters'>
            <div className='no-gutters dash-left-wrapper'>
              <DashboardHeader />
              <AddBlsData handleBackClick={() => handleBackClick()}/>
              <DashContentFooter />
            </div>
    
          </div>
    
        </DashboardContext.Provider>
      );
}

export default AddBrandLiftStudy;

